import { render, staticRenderFns } from "./newBussinessClassification.vue?vue&type=template&id=b0bffee0&scoped=true&"
import script from "./newBussinessClassification.vue?vue&type=script&lang=js&"
export * from "./newBussinessClassification.vue?vue&type=script&lang=js&"
import style0 from "./newBussinessClassification.vue?vue&type=style&index=0&id=b0bffee0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bffee0",
  null
  
)

export default component.exports